import { useState, useEffect } from 'react';

import { FormControl, FormHelperText, InputLabel, Select, MenuItem } from '@material-ui/core';
import PropTypes from 'prop-types';
import useVrackApi from '../../../hooks/useVrackApi';

const kitConfigStyles = {
  select: { minWidth: 200 }
};

SoftwareKitConfigSelect.propTypes = {
  kitID: PropTypes.string,
  kitIDType: PropTypes.string,
  kitConfig: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setKitConfig: PropTypes.func
};

export default function SoftwareKitConfigSelect({ kitID, kitIDType, kitConfig, setKitConfig }) {
  const [kitConfigList, setKitConfigList] = useState([]);
  const [buildType, setBuildType] = useState('srr');
  const { fetchData: fetchConfigs } = useVrackApi(
    'get',
    `/scmdb/builds/${kitID}/configs?type=${buildType}`
  );

  const handleChange = (event) => {
    setKitConfig(JSON.parse(event.target.value));
  };

  const updateKitConfigList = async () => {
    // updates the list of kit configs using the kit id and type specified
    await fetchConfigs({ url: `/scmdb/builds/${kitID}/configs?type=${buildType}` })
      .then((response) => {
        if (Array.isArray(response) && response.length > 0) {
          const configs = response.reverse();
          setKitConfigList(configs);
        } else {
          setKitConfigList([]);
        }
      })
      .catch((err) => {
        console.error('failed to retrieve kit configs', err);
        setKitConfigList([]);
        setKitConfig(null);
      });
  };

  useEffect(() => {
    // clear if kit is undefined or empty
    if (!kitID || kitID === '') {
      setKitConfigList([]);
      setKitConfig('');
      return;
    }
    updateKitConfigList();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [kitID, buildType]);

  useEffect(() => {
    // since the build type param we use to query the kit configs don't have 'kit' prepended to it,
    // we have to use a different variable for the querying
    if (kitIDType === 'kit_srr') {
      setBuildType('srr');
    } else {
      setBuildType('release_id');
    }
  }, [kitIDType]);

  return (
    <FormControl sx={kitConfigStyles.select} size="small" fullWidth>
      <InputLabel id="kit-config-select-label" data-testid="kit-config-select-label">
        Software Kit Configuration
      </InputLabel>
      <Select
        value={kitConfig ? JSON.stringify(kitConfig) : ''}
        labelId="kit-config-select-label"
        label="Software Kit Configuration"
        onChange={handleChange}
        autoWidth
        displayEmpty
      >
        {kitConfigList.length === 0 ? (
          <MenuItem disabled>
            <em>No Configs Found</em>
          </MenuItem>
        ) : null}
        {kitConfigList.map((config) => (
          <MenuItem key={config.name} value={JSON.stringify(config)}>
            {config.name} (pn: {config.partnumber} version: {config.version})
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>Specify which software kit configuration to load</FormHelperText>
    </FormControl>
  );
}
